import { render, staticRenderFns } from "./Dataset_Marker_grid.vue?vue&type=template&id=37aeaa0c&scoped=true&"
import script from "./Dataset_Marker_grid.vue?vue&type=script&lang=js&"
export * from "./Dataset_Marker_grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aeaa0c",
  null
  
)

export default component.exports